import { listingEnabledForUser } from '@fastre/core/schemas/saleListing'
import { useUsersApi } from 'apiProviders'
import { useUserData } from 'auth'
import DocusignFormStepper from './docusignFormStepper/index.js'
import { useListingContext } from './listingProvider'

export default function SellerDisclosureTab() {
    const { user } = useUserData()
    const { listing } = useListingContext()
    const usersApi = useUsersApi()

    const enabledForUser = listingEnabledForUser(listing, usersApi.data, user)

    return (
        <>
            <DocusignFormStepper
                title="Seller Disclosure"
                formType="sellerDisclosureForm"
                createDisabled={!enabledForUser || listing.vendors.length === 0}
                validate={() => true}
                preCreate={() => true}
                roleNames={['Vendor']}
            />
        </>
    )
}
